<div>
  <div class="flex flex-row flex-wrap my-3 justify-content-between align-items-center align-content-center">
    <div class="flex flex-column">
      <h3 class="text-base font-medium text-800 pr-2 m-0">
        {{'UserPages.UserProducts.PageTitle' | translate}}
      </h3>
      <span>{{'UserPages.UserProducts.PageDescription' | translate}}</span>
    </div>

    <p-button
      (onClick)="save()"
      icon="pi pi-save"
      label="{{'UserPages.UserContactInfo.SaveButton' | translate}}"
      styleClass="p-button-primary"
      class="custom-text-button"/>
  </div>

  <div class="p-fluid grid">
    <div class="col-12">
      <p-table [value]="species"
        [loading]="loading"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [(selection)]="selection"
        dataKey="id"
        responsiveLayout="stack"
        [breakpoint]="'600px'"
        class="custom-table">
        <ng-template pTemplate="header">
            <tr>
              <th>
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th>{{'UserPages.UserProducts.AllText' | translate}}</th>
              <th>
                <p-columnFilter
                  type="text"
                  [field]="getFilterField()"
                  [showButtons]="false"
                  placeholder="{{'UserPages.UserProducts.FilterFieldPlaceholder' | translate}}"
                  class="custom-input-filter">
                </p-columnFilter></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-specie>
            <tr>
              <td>
                <p-tableCheckbox [value]="specie"></p-tableCheckbox>
              </td>
              <td>
                <img
                  [src]="specie.imageUrl | speciesImageUrl"
                  [alt]="specie.name"
                  width="46"
                  style="border-radius: 7px;"/>
              </td>
              <td>{{specie | speciesName}}</td>
            </tr>
        </ng-template>
    </p-table>
    </div>
  </div>
</div>


